import {
  editApplicationsSaga,
  reloadApplicationsSaga,
  uploadApplicationsSaga,
} from "redux-store/applications";
import { forwardMessageSaga } from "redux-store/messages/sagas";
import { reloadNetworksSaga } from "redux-store/networks";
import {
  EDIT_USER_CONTENT_SUCCESS,
  UPLOAD_USER_CONTENT_SUCCESS,
} from "redux-store/user-contents/actions";
import {
  changePasswordSaga,
  userEditSaga,
  userInviteDetailsSaga,
  userInviteSaga,
  userRegistrationSaga,
} from "redux-store/users/sagas";
import {
  vistarAccountNetworksSaga,
  vistarAccountVenuesSaga,
} from "redux-store/vistar-accounts/sagas";

import { alertV3Sagas } from "./alerts-v3";
import {
  CREATE_CONTENT_FOLDER_SUCCESS,
  MOVE_TO_CONTENT_FOLDER_SUCCESS,
} from "./content-folders/actions";
import { contentFolderSagas } from "./content-folders/sagas";
import {
  CREATE_CONTENT_GROUP_SUCCESS,
  EDIT_CONTENT_GROUP_SUCCESS,
} from "./content-groups/actions";
import { contentGroupSagas } from "./content-groups/sagas";
import { deploymentsSagas } from "./deployments";
import { fleetInitSaga } from "./init/sagas";
import {
  MEDIA_LIBRARY_ARCHIVE_SUCCESS,
  mediaLibrarySagas,
} from "./media-library";
import { scheduledDeploymentsSagas } from "./scheduled-deployments/sagas";
import {
  ARCHIVE_STRATEGY_SUCCESS,
  EDIT_STRATEGY_SUCCESS,
  NEW_STRATEGY_SUCCESS,
  strategySagas,
} from "./strategies";

const applicationSagas = [
  editApplicationsSaga(),
  reloadApplicationsSaga(),
  uploadApplicationsSaga(),
];

const userSagas = [
  changePasswordSaga(),
  userEditSaga(),
  userInviteDetailsSaga(),
  userInviteSaga(),
  userRegistrationSaga(),
];

const vistarSagas = [vistarAccountNetworksSaga(), vistarAccountVenuesSaga()];

const messageForwarding = [
  ARCHIVE_STRATEGY_SUCCESS,
  CREATE_CONTENT_FOLDER_SUCCESS,
  CREATE_CONTENT_GROUP_SUCCESS,
  EDIT_CONTENT_GROUP_SUCCESS,
  EDIT_STRATEGY_SUCCESS,
  EDIT_USER_CONTENT_SUCCESS,
  MEDIA_LIBRARY_ARCHIVE_SUCCESS,
  MOVE_TO_CONTENT_FOLDER_SUCCESS,
  NEW_STRATEGY_SUCCESS,
  UPLOAD_USER_CONTENT_SUCCESS,
];

// Load any app specific sagas here.
const appSagas = [
  fleetInitSaga(),
  forwardMessageSaga(messageForwarding),
  reloadNetworksSaga(),
  ...alertV3Sagas,
  ...applicationSagas,
  ...contentFolderSagas,
  ...contentGroupSagas,
  ...deploymentsSagas,
  ...mediaLibrarySagas,
  ...scheduledDeploymentsSagas,
  ...strategySagas,
  ...userSagas,
  ...vistarSagas,
];

export { appSagas };
